<script>
  import { fade, slide } from "svelte/transition";
  export let img;
  export let name;
</script>

<main>
  <div
    in:slide={{ delay: 400, duration: 800 }}
    out:slide={{ delay: 400, duration: 800 }}
    class="md:w-40 md:h-40 w-20 h-20 bg-[#5A5A5A] hover:backdrop-blur-md hover:bg-opacity-100 hover:bg-blue-500 transition-all duration-300 p-4 rounded-md m-4 flex flex-col items-center justify-center md:space-y-4 backdrop-blur-xl bg-opacity-30"
  >
    <div class="w-8 mx-auto hover:scale-125 transition-all cursor-pointer">
      <img src={img} alt={img.split(".")[0]} class="w-8" />
    </div>
    <div>
      <h1 class="text-center text-base capitalize font-medium md:block hidden">
        {name}
      </h1>
    </div>
  </div>
</main>
